module.exports = __webpack_public_path__ + "static/4-620550bb4802db87ca6b1b9a551cdeb4.png";